import React from "react";

const RotateRight = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
    >
      <path
        d="M13.1848 3.2C11.738 1.76889 9.86119 0.888889 7.78886 0.888889C4.15249 0.888889 1.07918 3.58222 0 7.30667L1.84555 8C2.66667 5.16444 5.01271 3.11111 7.78886 3.11111C9.31378 3.11111 10.7058 3.75111 11.7928 4.78222L8.96188 8H16V0L13.1848 3.2Z"
        fill={color}
      />
    </svg>
  );
};

export default RotateRight;
